import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NAV_OFFSET = 80; // approx height of the fixed navbar

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (hash) {
      // Wait for section to render (route change may swap components)
      const attemptScroll = (attempt = 0) => {
        const el = document.querySelector(hash);
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;
          window.scrollTo({ top, behavior: "auto" });
          return;
        }
        if (attempt < 30) {
          setTimeout(() => attemptScroll(attempt + 1), 60);
        }
      };
      // start on next frame so the target page has mounted
      requestAnimationFrame(() => attemptScroll());
      return;
    }

    const scroll = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    scroll();
    const raf1 = requestAnimationFrame(scroll);
    const raf2 = requestAnimationFrame(scroll);
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [pathname, hash]);

  return null;
}
